const i18n = require("i18next").default || require("i18next");
const initReactI18next = require("react-i18next").initReactI18next;
const translationEN = require("./i18n/en/index.json");
const translationNL = require("./i18n/nl/index.json");
const memberDashboardEN = require("./i18n/en/memberDashboard.json");
const memberDashboardNL = require("./i18n/nl/memberDashboard.json");

i18n.use(initReactI18next).init({
  fallbackLng: ["en", "nl"],
  debug: false,
  interpolation: {
    escapeValue: false
  },
  resources: {
    en: {
      translations: translationEN,
      md: memberDashboardEN
    },
    nl: {
      translations: translationNL,
      md: memberDashboardNL
    }
  },
  react: {
    useSuspense: false,
    wait: true
  },
  ns: ["translations", "md"],
  defaultNS: "translations",
  lng: "en"
});

module.exports = i18n;
